import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE = 'https://intro.smartmediaclarity.com';
const DEFAULT_IMAGE = `${BASE}/og-image.png`;

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  type?: 'website' | 'article';
}

export default function SEO({ title, description, path, ogImage = DEFAULT_IMAGE, type = 'website' }: SEOProps) {
  const full = `${title} | SMCLA`;
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Smart Media Clarity" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
